// `description` repeats the prompt in AiMotionPresets.php (tooltip, Custom "Start from"): change both.
// `anim` selects the CSS hover diagram in AiMotionLibrary.vue.
export const AI_MOTION_PRESETS = [
  { key: 'float', label: 'Float', anim: 'float', description: 'Subject gently floats up and down in place, soft ambient motion.' },
  { key: 'slow-zoom', label: 'Slow zoom', anim: 'zoom', description: 'Slow, smooth push-in on the subject, cinematic parallax.' },
  { key: 'parallax', label: 'Parallax', anim: 'pan', description: 'Camera drifts sideways with layered parallax between foreground and background.' },
  { key: 'orbit', label: 'Orbit', anim: 'orbit', description: 'Camera subtly rotates around the product for a 3D effect.' },
  { key: 'pan', label: 'Pan', anim: 'slide', description: 'Camera moves smoothly left to right across the image.' },
  { key: 'tilt', label: 'Tilt', anim: 'tilt', description: 'Camera moves vertically to reveal the product from bottom to top.' },
  { key: 'pulse', label: 'Pulse', anim: 'pulse', description: 'Product gently scales up and down to draw attention.' },
  { key: 'sparkle', label: 'Sparkle', anim: 'twinkle', description: 'Subtle sparkles and light glints animate over the subject.' },
  { key: 'steam', label: 'Steam', anim: 'steam', description: 'Warm steam or vapor rises softly from the subject.' },
];

export const CUSTOM_PRESET_KEY = 'custom';

/**
 * Mirror of AiMotionPresets::labelFor(). The finished-clip broadcast already sends the
 * label, but while a clip is still in flight the client only holds the key it sent, and
 * the panel header has to name the preset it is generating (POR-13982).
 */
export function presetLabel(key) {
  if (key === CUSTOM_PRESET_KEY) {
    return 'Custom';
  }

  const preset = AI_MOTION_PRESETS.find(item => item.key === key);

  return preset ? preset.label : key;
}

// AiMotionCreditService::debitSql() always debits exactly 1, so the panel can state the
// cost without a round trip.
export const CREDITS_PER_CLIP = 1;

// POR-13982 specifies the .ai domain for this link; the rest of the app writes
// support@itsrapid.io (see AiMotionController's own out-of-credits message).
export const SUPPORT_EMAIL = 'support@itsrapid.ai';

export const CREDITS_REQUEST_SUBJECT = 'Video credits request';

// Deliberately narrower than VeoRequest::ALLOWED_CLIP_LENGTHS (which still accepts 6 and 8):
// longer clips read as an unfinished loop on a single scene, so the UI only offers 2-5s.
export const CLIP_LENGTHS = [2, 3, 4, 5];

export const DEFAULT_CLIP_LENGTH = 2;

// Mirror of VeoRequest::ALLOWED_CLIP_LENGTHS: what the backend accepts as clip_length.
const REQUEST_CLIP_LENGTHS = [2, 3, 4, 5, 6, 8];

const MAX_CLIP_LENGTH = REQUEST_CLIP_LENGTHS[REQUEST_CLIP_LENGTHS.length - 1];

const roundSeconds = seconds => Math.round(seconds * 100) / 100;

export function clipLengthOptions(duration) {
  const full = roundSeconds(duration);

  return [
    ...CLIP_LENGTHS.filter(length => length < full).map(length => ({ value: length, label: `${length}s` })),
    { value: full, label: `Full ${full}s` },
  ];
}

// The backend accepts 2-8s; the layer's End trims a longer clip.
export function requestClipLength(duration) {
  return REQUEST_CLIP_LENGTHS.find(length => length >= duration) ?? MAX_CLIP_LENGTH;
}

// Measured median across 12 spike clips was 41.8s. The API reports no percentage,
// so the progress bar interpolates against this and waits for the socket event.
export const ESTIMATED_SECONDS = 40;
